import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import fatcaQuestionnaireType from '../../life-config/fatcaQuestionConfig.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { map, startWith } from 'rxjs/operators';
import { SharedApiService } from '../../services/shared-api.service';
import { CountryInfo } from '../../model/data.model';
import trackingInfo from '../../life-config/journey-tracker.json';

@Component({
  selector: 'app-tata-defence',
  templateUrl: './tata-defence.component.html',
  styleUrls: ['./tata-defence.component.css']
})
export class TataDefenceComponent implements OnInit {

    questionnaireForm: FormGroup;
    fatcaQuestionnaireDetails: object = fatcaQuestionnaireType.FatcaQuestionnaireFormInitialJson;
    covidQuestionnaireDetails: object = fatcaQuestionnaireType.covidQuestion;
    defenceQuestionnaireDetails: object = fatcaQuestionnaireType.defenceQuestion;
    occupationQuestionnaireDetails: object = fatcaQuestionnaireType.occupationQuestion;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    trackInfo: object = trackingInfo['tracker-info'];
    birthCountryList: any;
    citizenCountryList: any;
    companyList: any;
    addressCountryList: any;
    taxResidencyCountry: any;
    addressStateList: any;
    addResidencyState: any;
    addressCityList: any;
    addressPincode: any;
    mergedCovidData: any;
    defenceData: any;
    proposalRes: any;
    fatcaData: any;
    finalDataToSend: any;
    tabListData: any;
    // residence_tax : any;

    uuid: string;
    proposalId: string;
    productType: object = lifeProductType.product_type;
    isLeftSectionLoader = false;
    isLoaderActivated = false;

    constructor(
                private apiService: ApiService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private datePipe: DatePipe,
                private sharedData: SharedApiService,
                private formbuild: FormBuilder) {
                this.questionnaireForm = this.formbuild.group({

                    /**
                     * Defence
                     */

                    defenceService: [ this.defenceQuestionnaireDetails['defenceService']['default'] ],
                    otherDefenceService: [],
                    rankDesignation: ['', [
                        Validators.required,
                        Validators.maxLength(25),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]],
                    currentLocationPosting: ['', [
                        Validators.required,
                        Validators.maxLength(25),
                        Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]],
                    natureOfRole: [ this.defenceQuestionnaireDetails['natureOfRole']['default']],
                    engagedHazardousActivity: [this.defenceQuestionnaireDetails['engagedHazardousActivity']['default']],
                    engagedHazardousActivityDesc: [],
                    currentlyServingActivity: [this.defenceQuestionnaireDetails['engagedHazardousActivity']['default']],
                    currentlyServingActivityDesc : [],
                    handlingExposive: [this.defenceQuestionnaireDetails['handlingExposive']['default']],
                    handlingExposiveDesc: [],


                });

                this.sharedData.tabEventData.subscribe(value => {
                    if (value) {

                        this.tabListData = value;


                    }
                });

                this.apiService.getStatusEvent.subscribe(value => {

                    if (value) {
                        const errorStatusFromApi = value['status'];

                        if ( errorStatusFromApi === 400 ) {

                            this.isLoaderActivated = false;
                        }
                    }


                });
    }


    /**
     * Feed proposal data
     */

    feedProposalData() {

        this.tabListData = this.sharedData.storeTabInfo();
        /***
         * Defence
         */

        if ( this.proposalRes['questions']['armed_services_branch']) {

            this.questionnaireForm.patchValue({ defenceService: this.proposalRes['questions']['armed_services_branch'] });
        }

        if (this.proposalRes['questions']['armed_services_branch_other']) {

            this.questionnaireForm.patchValue({ otherDefenceService: this.proposalRes['questions']['armed_services_branch_other'] });
        }

        if (this.proposalRes['questions']['rank_designation']) {

            this.questionnaireForm.patchValue({ rankDesignation: this.proposalRes['questions']['rank_designation'] });
        }

        if (this.proposalRes['questions']['posting_location']) {

            this.questionnaireForm.patchValue({ currentLocationPosting: this.proposalRes['questions']['posting_location'] });
        }

        if (this.proposalRes['questions']['defence_nature_of_job']) {

            this.questionnaireForm.patchValue({ natureOfRole: this.proposalRes['questions']['defence_nature_of_job'] });
        }





        this.questionnaireForm.patchValue({ engagedHazardousActivity: this.proposalRes['questions']['defence_hazardous_activities'] });
        this.questionnaireForm.patchValue({ engagedHazardousActivityDesc: this.proposalRes['questions']['defence_hazardous_detail'] });

        this.questionnaireForm.patchValue({ currentlyServingActivity: this.proposalRes['questions']['troubled_area'] });

        if ( this.proposalRes['questions']['troubled_area'] ) {

            this.questionnaireForm.patchValue({ currentlyServingActivityDesc: this.proposalRes['questions']['troubled_area_detail'] });
        }


        this.questionnaireForm.patchValue({ handlingExposive: this.proposalRes['questions']['handle_explosives'] });

        if ( this.proposalRes['questions']['handle_explosives']) {
            this.questionnaireForm.patchValue({ handlingExposiveDesc: this.proposalRes['questions']['handle_explosives_detail'] });
        }



        this.isLeftSectionLoader = false;


    }


    inBranchArmedServicesValidation() {

        const inTouchWithCovidInfo = this.questionnaireForm.get('otherDefenceService');
        this.questionnaireForm.get('defenceService').valueChanges.subscribe(
            (defenceOthers: number) => {

                if (defenceOthers === this.defenceQuestionnaireDetails['defenceService']['others'] ) {


                    inTouchWithCovidInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [Validators.required, Validators.minLength(1), Validators.maxLength(25),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]
                    );
                }
                if (defenceOthers !== this.defenceQuestionnaireDetails['defenceService']['others']) {

                    inTouchWithCovidInfo.setValidators(null);

                }

                inTouchWithCovidInfo.updateValueAndValidity();

            });
    }

    hazardousActivityValidation() {

        const inTouchWithCovidInfo = this.questionnaireForm.get('engagedHazardousActivityDesc');
        this.questionnaireForm.get('engagedHazardousActivity').valueChanges.subscribe(
            (defenceOthers: boolean) => {

                if (defenceOthers ) {


                    inTouchWithCovidInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [Validators.required, Validators.minLength(1), Validators.maxLength(25),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]
                    );
                }
                if (!defenceOthers) {

                    inTouchWithCovidInfo.setValidators(null);

                }

                inTouchWithCovidInfo.updateValueAndValidity();

            });

    }


    currentlyServingActivityValidation() {

        const inTouchWithCovidInfo = this.questionnaireForm.get('currentlyServingActivityDesc');
        this.questionnaireForm.get('currentlyServingActivity').valueChanges.subscribe(
            (defenceOthers: boolean) => {

                if (defenceOthers ) {


                    inTouchWithCovidInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [Validators.required, Validators.minLength(1), Validators.maxLength(25),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]
                    );
                }
                if (!defenceOthers) {

                    inTouchWithCovidInfo.setValidators(null);

                }

                inTouchWithCovidInfo.updateValueAndValidity();

            });

    }


    handlingExposiveValidation() {

        const inTouchWithCovidInfo = this.questionnaireForm.get('handlingExposiveDesc');
        this.questionnaireForm.get('handlingExposive').valueChanges.subscribe(
            (defenceOthers: boolean) => {

                if (defenceOthers ) {


                    inTouchWithCovidInfo.setValidators(
                        // tslint:disable-next-line: max-line-length
                        [Validators.required, Validators.minLength(1), Validators.maxLength(25),  Validators.pattern(new RegExp('^[a-zA-Z0-9 ]+$'))]
                    );
                }
                if (!defenceOthers) {

                    inTouchWithCovidInfo.setValidators(null);

                }

                inTouchWithCovidInfo.updateValueAndValidity();

            });

    }

    /** Save Form data */

    saveDefenceFormData(isValid: boolean, event) {

        if (isValid) {

            this.isLoaderActivated = true;
            const defenceData = {
                armed_services_branch: this.questionnaireForm.get('defenceService').value,

                rank_designation: this.questionnaireForm.get('rankDesignation').value,
                posting_location: this.questionnaireForm.get('currentLocationPosting').value,
                defence_nature_of_job: this.questionnaireForm.get('natureOfRole').value,
                defence_hazardous_activities: this.questionnaireForm.get('engagedHazardousActivity').value,
                troubled_area: this.questionnaireForm.get('currentlyServingActivity').value,

                handle_explosives: this.questionnaireForm.get('handlingExposive').value,


            };

            this.defenceData = defenceData;

            if (this.questionnaireForm.get('defenceService').value === 7 ) {

                    const armedServiceOther = {

                        armed_services_branch_other: this.questionnaireForm.get('otherDefenceService').value,



                    };


                    this.defenceData = Object.assign({}, this.defenceData, armedServiceOther);
            }


            if (this.questionnaireForm.get('engagedHazardousActivity').value ) {

                const armedServiceOther = {

                    defence_hazardous_detail: this.questionnaireForm.get('engagedHazardousActivityDesc').value,



                };


                this.defenceData = Object.assign({}, this.defenceData, armedServiceOther);
            }


            if (this.questionnaireForm.get('currentlyServingActivity').value ) {

                const armedServiceOther = {

                    troubled_area_detail: this.questionnaireForm.get('currentlyServingActivityDesc').value,



                };


                this.defenceData = Object.assign({}, this.defenceData, armedServiceOther);
            }


            if (this.questionnaireForm.get('handlingExposive').value ) {

                const armedServiceOther = {

                    handle_explosives_detail: this.questionnaireForm.get('handlingExposiveDesc').value,



                };


                this.defenceData = Object.assign({}, this.defenceData, armedServiceOther);
            }


            const mergedObjectInfoData: any = {

                questions: Object.assign({},   this.defenceData),
                journey_track: this.trackInfo['QUESTIONNAIRE']
            };

            this.finalDataToSend =  Object.assign({}, mergedObjectInfoData);

            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'],
                this.finalDataToSend).subscribe(res => {

                if (res) {

                    this.isLoaderActivated = false;
                    if (this.tabListData && this.tabListData.length > 1) {

                        /**
                         * check for movement
                         * check by name and its current componet
                         * movement decision
                         */

                        this.tabListData.forEach((element, index) => {
                            if (element['type'] === 'defence') {

                                if(index < (this.tabListData.length) - 1) {

                                    this.sharedData.getNextCrntActiveTab(this.tabListData[index + 1] , 1);
                                } else {
                                    
                                    this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                                }
                            }

                         });




                    } else {

                        this.router.navigate(['/life/acr', this.proposalId, this.uuid]);
                    }

                }

            },
                err => {
                    console.log('sonething went at our end', err);
                });
        }

    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        // Get propsoal info

        if (this.uuid && this.proposalId) {

            this.isLeftSectionLoader = true;
            this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
                if (res) {

                    this.proposalRes = res;


                    if (this.proposalRes) {

                        this.feedProposalData();
                        this.inBranchArmedServicesValidation();
                        this.hazardousActivityValidation();
                        this.currentlyServingActivityValidation();
                        this.handlingExposiveValidation();

                    }
                }

            });


        }
    }



    /**
     * Back btn
     */




    backBtnFromPersonalDetails() {
        this.router.navigate(['/life/upload-document', this.proposalId, this.uuid])
        .then(() => {
            window.location.reload();
        });

    }

}

